import FalconLogMonitor from "./FalconLogMonitor";
export default FalconLogMonitor;
